const PaymentStatus = {
  Pending: 'pending',
  Accepted: 'accepted',
  Partial: 'partial',
  Rejected: 'rejected',
};

export default PaymentStatus;
